module.exports = __webpack_public_path__ + "img/Number=48.c3b47937.png";